const formatDate = (date) => {
    return new Intl.DateTimeFormat('en', {
        dateStyle: 'medium',
        timeStyle: 'short',
        hourCycle: 'h23'
    }).format(date);
};

export default formatDate;